"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COUNTRY_CODE_MAPPING = exports.getImportPostalCodeLabel = exports.getImportRegionLabel = exports.isUnitedKingdomImportOnUnitedStatesOrganization = void 0;
const country_1 = require("../enums/country");
const isUnitedKingdomImportOnUnitedStatesOrganization = (organizationCountry, importCountry) => organizationCountry === country_1.OrganizationCountry.UnitedStates && importCountry === country_1.CountryCode.GB;
exports.isUnitedKingdomImportOnUnitedStatesOrganization = isUnitedKingdomImportOnUnitedStatesOrganization;
const getImportRegionLabel = (country) => {
    return country === country_1.OrganizationCountry.Australia ? "State/Territory" : "Region";
};
exports.getImportRegionLabel = getImportRegionLabel;
const getImportPostalCodeLabel = (country) => {
    return country === country_1.OrganizationCountry.Australia ? "Postcode" : "Postal Code";
};
exports.getImportPostalCodeLabel = getImportPostalCodeLabel;
/**
 * Mapping of common country names and 3-letter codes to 2-letter ISO codes
 */
exports.COUNTRY_CODE_MAPPING = {
    // United States variations
    US: "US",
    "UNITED STATES": "US",
    "UNITED STATES OF AMERICA": "US",
    "UNITED STATE": "US", // Common typo
    USA: "US",
    "U.S.A": "US",
    "U.S.A.": "US",
    "U.S": "US",
    "U.S.": "US",
    "US OF A": "US",
    AMERICA: "US",
    AMÉRIQUE: "US",
    "ÉTATS-UNIS": "US",
    "ETATS-UNIS": "US",
    "ESTADOS UNIDOS": "US", // Spanish
    "ESTADOS UNIDOS DE AMÉRICA": "US", // Spanish
    "STATI UNITI": "US", // Italian
    "VERENIGDE STATEN": "US", // Dutch
    "VEREINIGTE STAATEN": "US", // German
    "ÉTATS-UNIS D'AMÉRIQUE": "US", // French full name
    // Canada variations
    CA: "CA",
    CANADA: "CA",
    CAN: "CA",
    CANADÁ: "CA", // Spanish
    CANADÀ: "CA", // Catalan
    KANADA: "CA", // German/Dutch
    CANADIEN: "CA", // French adjective form (sometimes used)
    // France variations
    FRANCE: "FR",
    FRA: "FR",
    // United Kingdom variations
    GB: "GB",
    "UNITED KINGDOM": "GB",
    "UNITED KINGDOM OF GREAT BRITAIN AND NORTHERN IRELAND": "GB",
    UK: "GB",
    "U.K.": "GB",
    "U.K": "GB",
    BRITAIN: "GB",
    "GREAT BRITAIN": "GB",
    "BRITISH ISLES": "GB",
    BRITANNIA: "GB",
    ENGLAND: "GB",
    SCOTLAND: "GB",
    WALES: "GB",
    "NORTHERN IRELAND": "GB",
    GBR: "GB",
    "ROYAUME-UNI": "GB", // French
    "ROYAUME-UNI DE GRANDE-BRETAGNE": "GB", // French full name
    "GRANDE-BRETAGNE": "GB", // French
    ANGLETERRE: "GB", // French (sometimes used for UK)
    "VEREINIGTES KÖNIGREICH": "GB", // German
    "REINO UNIDO": "GB", // Spanish
    "REGNO UNITO": "GB", // Italian
    "VERENIGD KONINKRIJK": "GB", // Dutch
    // Germany variations
    GERMANY: "DE",
    DEUTSCHLAND: "DE",
    ALLEMAGNE: "DE",
    DEU: "DE",
    GER: "DE",
    // Spain variations
    SPAIN: "ES",
    ESPAÑA: "ES",
    ESPAGNE: "ES",
    ESP: "ES",
    // Italy variations
    ITALY: "IT",
    ITALIA: "IT",
    ITALIE: "IT",
    ITA: "IT",
    // Mexico variations
    MEXICO: "MX",
    MÉXICO: "MX",
    MEXIQUE: "MX",
    MEX: "MX",
    // Australia variations
    AU: "AU",
    AUSTRALIA: "AU",
    AUS: "AU",
    AUSTRALIE: "AU", // French
    AUSTRALIEN: "AU", // German
    AUSTRALIË: "AU", // Dutch
    "COMMONWEALTH OF AUSTRALIA": "AU", // Official name
    AUSSIE: "AU", // Informal
    // Japan variations
    JAPAN: "JP",
    JAPON: "JP",
    JPN: "JP",
    // China variations
    CHINA: "CN",
    CHINE: "CN",
    CHN: "CN",
    // India variations
    INDIA: "IN",
    INDE: "IN",
    IND: "IN",
    // Brazil variations
    BRAZIL: "BR",
    BRASIL: "BR",
    BRÉSIL: "BR",
    BRA: "BR",
    // Netherlands variations
    NETHERLANDS: "NL",
    "THE NETHERLANDS": "NL",
    HOLLAND: "NL",
    "PAYS-BAS": "NL",
    NLD: "NL",
    // Belgium variations
    BELGIUM: "BE",
    BELGIQUE: "BE",
    BELGIË: "BE",
    BEL: "BE",
    // Switzerland variations
    SWITZERLAND: "CH",
    SUISSE: "CH",
    SCHWEIZ: "CH",
    SVIZZERA: "CH",
    CHE: "CH",
    // Portugal variations
    PORTUGAL: "PT",
    PRT: "PT",
    // Poland variations
    POLAND: "PL",
    POLSKA: "PL",
    POLOGNE: "PL",
    POL: "PL",
    // Sweden variations
    SWEDEN: "SE",
    SVERIGE: "SE",
    SUÈDE: "SE",
    SWE: "SE",
    // Norway variations
    NORWAY: "NO",
    NORGE: "NO",
    NORVÈGE: "NO",
    NOR: "NO",
    // Denmark variations
    DENMARK: "DK",
    DANMARK: "DK",
    DANEMARK: "DK",
    DNK: "DK",
    // Finland variations
    FINLAND: "FI",
    SUOMI: "FI",
    FINLANDE: "FI",
    FIN: "FI",
    // Ireland variations
    IRELAND: "IE",
    ÉIRE: "IE",
    IRLANDE: "IE",
    IRL: "IE",
    // Austria variations
    AUSTRIA: "AT",
    ÖSTERREICH: "AT",
    AUTRICHE: "AT",
    AUT: "AT",
    // Greece variations
    GREECE: "GR",
    GRÈCE: "GR",
    ΕΛΛΆΔΑ: "GR",
    GRC: "GR",
    // Turkey variations
    TURKEY: "TR",
    TÜRKİYE: "TR",
    TURQUIE: "TR",
    TUR: "TR",
    // South Korea variations
    "SOUTH KOREA": "KR",
    KOREA: "KR",
    "REPUBLIC OF KOREA": "KR",
    "CORÉE DU SUD": "KR",
    KOR: "KR",
    // New Zealand variations
    "NEW ZEALAND": "NZ",
    "NOUVELLE-ZÉLANDE": "NZ",
    NZL: "NZ",
    // Russia variations
    RUSSIA: "RU",
    RUSSIE: "RU",
    RUS: "RU",
    // South Africa variations
    "SOUTH AFRICA": "ZA",
    "AFRIQUE DU SUD": "ZA",
    ZAF: "ZA",
    // Argentina variations
    ARGENTINA: "AR",
    ARGENTINE: "AR",
    ARG: "AR",
    // Chile variations
    CHILE: "CL",
    CHILI: "CL",
    CHL: "CL",
};
